import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, EDIT, YES, ACTIVE } from "const"
import {
    StoreType,
    moduleIds,
    setSilDeviceBaseRoute,
} from "client/store"
import {
    projectsRoute,
    projectBaseRoute,
    silDevicesRoute,
    silSubsystemsRoute,
} from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"

import List from "./list"
import DeviceView from "./deviceView"
import DeviceEdit from "./deviceEdit"
import SubsystemView from "./subsystemView"
import SubsystemEdit from "./subsystemEdit"

const SilDevice = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const dispatch = useDispatch()

    const { silModuleAccess } = packageSettings
    const moduleAccess = silModuleAccess === YES && moduleList[moduleIds.sil].status === ACTIVE
    const access = userData.accountId === 1 || moduleAccess

    const baseDeviceRouteMask = project.id ? `${projectBaseRoute}${silDevicesRoute}` : silDevicesRoute
    const baseDeviceRoute = project.id ? `${projectsRoute}/${VIEW}/${project.id}${silDevicesRoute}` : silDevicesRoute

    const baseSubsystemRouteMask = project.id ? `${projectBaseRoute}${silSubsystemsRoute}` : silSubsystemsRoute
    const baseSubsystemRoute = project.id ? `${projectsRoute}/${VIEW}/${project.id}${silSubsystemsRoute}` : silSubsystemsRoute

    useEffect(() => {
        dispatch(setSilDeviceBaseRoute(baseDeviceRoute, baseSubsystemRoute))
    }, [])

    if (!access) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${baseDeviceRouteMask}/${VIEW}/:deviceId`}
                component={DeviceView}
            />
            <Route
                path={`${baseDeviceRouteMask}/${EDIT}/:deviceId`}
                component={DeviceEdit}
            />
            <Route
                path={baseDeviceRouteMask}
                component={List}
            />


            <Route
                path={`${baseSubsystemRouteMask}/${VIEW}/:subsystemId`}
                component={SubsystemView}
            />
            <Route
                path={`${baseSubsystemRouteMask}/${EDIT}/:subsystemId`}
                component={SubsystemEdit}
            />
            <Route
                path={baseSubsystemRouteMask}
                component={List}
            />
        </Switch>
    )
}
export default SilDevice
